import { HomeRightSidebar } from "@/react/components/HomePageV2/HomeRightSidebar";
import { StandardLayout } from "@/react/components/Layout/StandardLayout";
import { useIsLoadingAppData } from "@/react/hooks/useIsLoadingAppData";
import { useSpacesContext } from "@circle-react/contexts";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { SkeletonLoader } from "@circle-react-uikit/SkeletonLoader";
import { useHomepageContext } from "./HomepageContext";

export const RightSidebarContent = () => {
  const { isLoading } = useSpacesContext();
  const isLoadingAppData = useIsLoadingAppData();
  const { hasSidebarContent } = useHomepageContext();

  if ((isLoading || isLoadingAppData) && hasSidebarContent) {
    return <SkeletonLoader variant="right-sidebar" count={6} />;
  }

  return (
    <StandardLayout.Right
      className={classNames({
        "!hidden": !hasSidebarContent,
      })}
    >
      <div className="sidebar__content">
        {/*#TODO:REACTIFICATION Handle onboarding steps for new community*/}
        <HomeRightSidebar />
      </div>
    </StandardLayout.Right>
  );
};
RightSidebarContent.propTypes = {};
